"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnCnCny = exports.ZhCnCny = void 0;
class ZhCnCny {
    constructor() {
        this.locale = "zh-cn";
        this.dateFormat = {
            short: "yyyy/M/d",
            medium: "MMMM dd, yyyy",
            long: "yyyy'年'M'月'd'日'",
        };
        this.currencyFormat = {
            code: "CNY",
            symbol: "元",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "n C",
            negativePattern: "C-n"
        };
    }
}
exports.ZhCnCny = ZhCnCny;
class EnCnCny {
    constructor() {
        this.locale = "en-cn";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "MMMM dd, yyyy",
            long: "dd MMMM yyyy",
        };
        this.currencyFormat = {
            code: "CNY",
            symbol: "元",
            decimalSeparator: ".",
            groupSeparator: ",",
            positivePattern: "n C",
            negativePattern: "-Cn"
        };
    }
}
exports.EnCnCny = EnCnCny;
